import request, {METHODS} from '@/api'
import UrlConfig from '@/api/UrlConfigs'
import {get} from 'lodash-es'

/**
 * 线索账号管理 - 账号列表
 */
export const launchAccountList = (current, pageSize, params) => {
  return request(
    `${UrlConfig.PlusClueWeb.LaunchAccountSearch}?pageId=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data: {
        "queryAdvertName": true,
        "queryOrgName": true,
        "queryChannelName": true,
        "queryAgentName": true,
        "queryChannelBrandName": true,
        "queryChannelTypeName": true,
        ...params
      },
    }
  ).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
/**
 * 线索账号变更记录-分页列表
 */
export const launchAccountChangeLogPage = (current, pageSize, params) => {
  return request(
    `${UrlConfig.PlusClueWeb.LaunchAccountChangeLogSearchPage}?pageId=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data: params,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
/**
 * 投放账号现金消费配置-分页列表
 */
export const launchAccountCashAllocationConfigPage = (current, pageSize, params) => {
  return request(
    `${UrlConfig.PlusClueWeb.LaunchAccountCashAllocationConfigSearchPage}?pageId=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data: params,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
/**
 * 线索账号-保存
 */
export const updateLaunchAccount = data => {
  return request(UrlConfig.PlusClueWeb.LaunchAccountUpdateById, {
    method: METHODS.POST,
    data: data,
  }).then((resp: any) => {
    return resp
  })
}
/**
 * 线索账号-删除
 */
export const deleteLaunchAccount = id => {
  return request(`${UrlConfig.PlusClueWeb.LaunchAccountOperate}/${id}`, {
    method: METHODS.DELETE,
  })
}
/**
 * 投放账号现金消费配置-删除
 */
export const deleteLaunchAccountCashAllocationConfig = id => {
  return request(`${UrlConfig.PlusClueWeb.LaunchAccountCashAllocationConfigOperate}/${id}`, {
    method: METHODS.DELETE,
  })
}
/**
 * 枚举值参数获取
 */
export const getDataDictionaries = path => {
  if (!path) {
    return []
  }
  return request(`${UrlConfig.PlusClueWeb.GetQvEnumAll}${path}`, {
    method: METHODS.GET,
  }).then(resp => {
    return resp
  })
}

// 获取供应商列表
export function getAgents(data={}): Promise<any[]> {
  return request(UrlConfig.PlusClueWeb.GetLaunchAccountAgent, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
// 获取供应商分页
export function getAgentsPage(options) {
  return request(UrlConfig.PlusClueWeb.GetLaunchAccountAgentPage, {
    method: METHODS.POST,
    ...options,
  })
}
export function agentsUpdateById(data) {
  return request(UrlConfig.PlusClueWeb.LaunchAccountAgentUpdateById, {
    method: METHODS.POST,
    data,
  })
}
export function agentsAdd(data) {
  return request(UrlConfig.PlusClueWeb.LaunchAccountAgentAdd, {
    method: METHODS.POST,
    data,
  })
}
export function delLaunchAccountAgent(id) {
  return request(UrlConfig.PlusClueWeb.DelLaunchAccountAgent + id, {
    method: METHODS.DELETE,
  })
}

// 线索军种
export function getChannelType(data = {}): Promise<any[]> {
  return request(UrlConfig.PlusClueWeb.GetChannelType, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export function getChannelTypePage(options) {
  return request(UrlConfig.PlusClueWeb.GetChannelTypePage, {
    method: METHODS.POST,
    ...options,
  })
}
export function channelTypeUpdateById(data) {
  return request(UrlConfig.PlusClueWeb.ChannelTypeUpdateById, {
    method: METHODS.POST,
    data,
  })
}
export function channelTypeAdd(data) {
  return request(UrlConfig.PlusClueWeb.ChannelTypeAdd, {
    method: METHODS.POST,
    data,
  })
}
export function delChannelType(id) {
  return request(UrlConfig.PlusClueWeb.DelChannelType + id, {
    method: METHODS.DELETE,
  })
}

// 线索品牌
export function getChannelBrandAgent(data = {}): Promise<any[]> {
  return request(UrlConfig.PlusClueWeb.GetChannelBrand, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export function getChannelBrandPage(options) {
  return request(UrlConfig.PlusClueWeb.GetChannelBrandPage, {
    method: METHODS.POST,
    ...options,
  })
}
export function channelBrandUpdateById(data) {
  return request(UrlConfig.PlusClueWeb.ChannelBrandUpdateById, {
    method: METHODS.POST,
    data,
  })
}
export function channelBrandAdd(data) {
  return request(UrlConfig.PlusClueWeb.ChannelBrandAdd, {
    method: METHODS.POST,
    data,
  })
}
export function delChannelBrand(id) {
  return request(UrlConfig.PlusClueWeb.DelChannelBrand + id, {
    method: METHODS.DELETE,
  })
}

export function transformationDept(list: any[]): void {
  for (let i = 0; i < list.length; i++) {
    const dept = list[i]
    dept.disable = true
    dept.label = dept.label
    dept.value = dept.object.id
    dept.key = dept.id
    if (dept.children) {
      transformationDept(dept.children)
    }
  }
}
export function transformationChannel(list: any[]): void {
  for (let i = 0; i < list.length; i++) {
    const channel = list[i]
    channel.label = channel.label
    channel.value = channel.id
    channel.key = channel.id + '_category'
    if (channel.children) {
      channel.disable = true
      transformationChannel(channel.children)
    } else {
      channel.children = channel.object.channels
      const child = channel.children
      for (let m = 0; m < child.length; m++) {
        child[m].label = child[m].channelName
        child[m].value = child[m].id
        child[m].key = child[m].id + '_channel'
      }
    }
  }
}
// 获取公司列表
export function queryAllDecoCompany(): Promise<any[]> {
  return request(UrlConfig.Caas.GetPrivilegesComPany, {
    method: METHODS.GET,
    data: {},
  }).then((resp: any) => {
    return resp
  })
}
// 获取部门列表
export const getDepartmentTree = companyCode => {
  if (!companyCode) {
    return new Promise(resolve => resolve([]))
  }
  return request(UrlConfig.Caas.GetQueryDeptListt+companyCode, {
    method: METHODS.POST,
    params: {
      // parentId: companyCode,
    },
    data: {},
  }).then((res: any) => {
    const list = res || []
    transformationDept(list)
    return list
  })
}
// 获取优化师
export const getAdvertWorkerList = data => {
  if (!data?.userIdentityFilter?.orgId) {
    return new Promise(resolve => resolve([]))
  }
  return request(UrlConfig.Caas.GetNoPrivilegesList, {
    method: METHODS.POST,
    data: data,
  }).then((res: any) => {
    return res
  })
}
// 获取军种列表
export const getChannelTypeIds = () => {
  return request(UrlConfig.PlusClueWeb.GetChannelTypeIds, {
    method: METHODS.POST,
    data: {
      // enabled: 1, //启用
      // parentKey: 'armyServices', //key
    },
  }).then((res: any) => {
    return res
  })
}
// 获取渠道树列表
export const getChannels = () => {
  return request(UrlConfig.PlusClueWeb.getChannelTree, {
    method: METHODS.POST,
    data: {},
  }).then((res: any) => {
    const list = res
    transformationChannel(list)
    return list
  })
}
// 获取业务线列表
export const getBusinessLines = () => {
  return request(UrlConfig.PlusClueWeb.GetChannelBrandList, {
    method: METHODS.POST,
    data: {},
  }).then((res: any) => {
    return res
  })
}
// 获取平台列表
export const getPlatforms = () => {
  return request(UrlConfig.PlusClueWeb.GetLaunchPlatformList, {
    method: METHODS.GET,
    data: {},
  }).then((res: any) => {
    return res
  })
}
// 线索账号提交
export const finishLaunchAccount = (url, data) => {
  return request(url, {
    method: METHODS.POST,
    data: data,
  }).then((res: any) => {
    return res
  })
}
//经营区域
export const storageLocationPage = (current, pageSize, params) => {
  // return request(
  //   `${UrlConfig.Config.GetCrmCompanyBusRegionSearchPage}?pageId=${current}&pageSize=${pageSize}`,
  //   {
  //     method: METHODS.POST,
  //     data: params,
  //   }
  // ).then((resp: any) => {
  //   const records = get(resp, 'list')
  //   const total = get(resp, 'count')
  //   return { records, total }
  // })
}
/**
 * 经营区域---删除
 */
export const storageLocationDel = id => {
  // return request(`${UrlConfig.Config.CrmCompanyBusRegionOperate}/${id}`, {
  //   method: METHODS.DELETE,
  // })
}
//经营区域 获取详情
export const getStorageLocationId = id => {
  // return request(`${UrlConfig.Config.CrmCompanyBusRegionOperate}/${id}`, {
  //   method: METHODS.GET,
  // }).then((resp: any) => {
  //   return resp
  // })
}
//经营区域树
export const getRuleCompanyBusRegionList = () => {
  // return request(UrlConfig.Config.GetRegionTreeAll, {
  //   method: METHODS.POST,
  //   data: {},
  // }).then((res: any) => {
  //   return res
  // })
}
//终端列表-带权限
export const getTenantList = () => {
  // return sviRequest(UrlConfig.SviTerminal.SviTerminalGetAllows, {
  //   method: METHODS.GET,
  // }).then((res: any) => {
  //   return res
  // })
}
// 经营区域--提交
export const finishStorageLocation = (url, data) => {
  return request(url, {
    method: METHODS.POST,
    data: data,
  }).then((res: any) => {
    return res
  })
}
//投放平台
export const getlaunchPlatformList = (current, pageSize, params) => {
  return request(
    `${UrlConfig.PlusClueWeb.LaunchPlatformSearchPage}?pageId=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data: params,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list')
    const total = get(resp, 'count')
    return { records, total }
  })
}
/**
 * 投放平台---删除
 */
export const launchPlatformDel = id => {
  return request(`${UrlConfig.PlusClueWeb.LaunchPlatformOperate}/${id}`, {
    method: METHODS.DELETE,
  })
}
/**
 * 投放平台-获取
 */
export const getLaunchPlatform = id => {
  return request(`${UrlConfig.PlusClueWeb.LaunchPlatformOperate}/${id}`, {
    method: METHODS.GET,
  }).then((res: any) => {
    return res
  })
}
//投放平台
export const updateLaunchPlatform = (url, data) => {
  return request(url, {
    method: METHODS.POST,
    data: data,
  }).then((res: any) => {
    return res
  })
}
// 查询下级数据字典列表
export const getChildrenDicts = keys => {
  return request(`/caas-web/dataDictionary/getChildrenDicts`, {
    method: METHODS.POST,
    data: [...keys],
  })
}
